<template>
    <div class="coupon-item">
        <img class="coupon-item-img" :src="`/api/v1/file/${item.cover}`" alt="">
        <div class="coupon-item-title">{{item.title}}</div>
        <div class="coupon-item-price">价格：<span class="f-20">{{+item.price|parseMoney}}</span>/张</div>
        <div class="coupon-item-time">使用日期：
            {{item.valid_start?item.valid_start.substr(0,10):''}} - {{item.valid_end?item.valid_end.substr(0,10):''}}
        </div>
        <el-button class="coupon-btn" type="primary" v-if="showBuy" @click="toDetail">立即购买</el-button>
    </div>
</template>

<script>
    export default {
        name: "CouponItem",
        props: {
            item: {
                type: Object,
                default() {
                    return {}
                }
            },
            showBuy:{
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                key: ''
            }
        },
        methods: {
            toDetail() {
                this.$router.push({path: '/couponDetail', query:{id: this.item.id}})
            }
        },
    }
</script>

<style scoped lang="less">
    .coupon-item {
        width: 100%;
        height: 130px;
        border-bottom: 1px solid #e2e2e2;
        padding: 20px;
        padding-left: 160px;
        box-sizing: border-box;
        position: relative;
        .coupon-item-title{
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 10px;
        }
        .coupon-item-price{
            font-size: 14px;
            color: #e44646;
            margin-bottom: 10px;

        }
        .coupon-item-time{
            font-size: 14px;
            color: #949494;
        }

        .coupon-btn{
            position: absolute;
            top: 50%;
            right: 20px;
            transform: translate(0, -50%);
        }
        .coupon-item-img{
            width: 100px;
            height: 100px;
            border-radius: 8px;
            position: absolute;
            top: 50%;
            left: 20px;
            transform: translate(0, -50%);
            object-fit: cover;
        }
    }

</style>
